<template>
    <div class="mainnav">
        <ul class="mainnav__wrapper">
            <li class="mainnav__element" v-for="item in menuitems">
                <a v-html="item.title" :href="item.url"></a>
            </li>
            <Social/>
        </ul>
    </div>
</template>

<script>
    import Social from './Social.vue'

    let ax = axios.create({
        baseURL: 'http://hessestudios.de/wp/wp-json/hessestudios/menu'
    });
    export default {
        name: 'MainNavigation',
        components: {
            Social
        },
        data(){
            return {
                menuitems: []
            };
        },
        mounted(){
            ax.get().then(response => {
                this.menuitems = response.data;
            });
        }
    }
</script>

<style lang="scss">
    @import "../../assets/styles/components/mainnavigation.scss";
</style>
